<router-outlet></router-outlet>

<div class="tw-flex tw-flex-wrap tw-gap-4 tw-mt-4">
  <div class="tw-w-full">
    <a bitButton bitIconButton="bwi-angle-left" routerLink="./" *ngIf="!homepage">
      {{ "backToReports" | i18n }}
    </a>
  </div>
</div>
